import { Section, Card, Note, Fields, Shot } from '../../../components/docs/Blocks';

export default function Console() {
  return (
    <Section
      id="console"
      title="Console"
      lead="What the program has done this session. Worth a look when something has gone wrong, and ignorable the rest of the time."
    >
      <Shot
        name="console"
        alt="The Console showing this session’s log with filter and auto-scroll controls"
      />

      <Card>
        <Fields
          items={[
            ['The log', 'Every operation, in order, with a level and the area it came from — world, save, backup, navigation, add-ons. The header says at a glance whether the session is running normally, has warnings, or has hit errors.'],
            ['Session', 'Since 3.0.4, any of the last ten sessions, read back from disk. Sessions that did not shut down cleanly are marked as crashed. An earlier session is a record: new messages from this one appear only under Current session.'],
            ['Filter', 'Narrow to a level when the log is busy.'],
            ['Auto scroll', 'Follows the newest entry. Turn it off to read back without being dragged forward.'],
            ['Save Log', 'Writes the log to a file you choose — the thing to attach to a bug report.'],
            ['Clear', 'Empties the view.'],
          ]}
        />
      </Card>

      <div className="mt-4">
        <Card title="Logs are written to disk too">
          <p>
            Unlike version 2, which kept its log in memory only, version 3 writes one
            file per session as it goes. That matters because the moment a log is most
            useful — a crash — is the one moment an in-memory log is guaranteed to be
            gone.
          </p>
          <p>
            The ten most recent sessions are kept, in the logs folder listed in
            Settings.
          </p>
          <Note>
            If the previous session ended unexpectedly, Toolchest says so on the next
            launch and opens the log from that session here if you ask. No world is affected by this —
            the log records what the program was doing, not what it changed.
          </Note>
        </Card>
      </div>

      <div className="mt-4">
        <Card title="Getting to it">
          <p>
            Console sits in the rail below the editing sections and is reachable with
            or without a world open. The failure dialogs that can afford a second
            button also offer <strong>View log</strong>, which jumps straight here.
          </p>
        </Card>
      </div>
    </Section>
  );
}
